import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=7359ba9b&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"
import style0 from "./Page.vue?vue&type=style&index=0&id=7359ba9b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7359ba9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7359ba9b')) {
      api.createRecord('7359ba9b', component.options)
    } else {
      api.reload('7359ba9b', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=7359ba9b&scoped=true", function () {
      api.rerender('7359ba9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Search/Page.vue"
export default component.exports